

















import { Component, Watch, Vue, Prop } from 'vue-property-decorator';


@Component({
  components: {
  },
})
export default class NineWords extends Vue {
  @Prop()
  public words: string[];

  @Prop()
  public title: string;

  @Prop()
  public value: {[word: string]: number};

  private key(word: string, n: number) {
      return `${word}-${n}`;
  }

  private selectedValue(word: string, n: number) {
      return this.selected[this.key(word, n)];
  }

  private emitResult() {
      const counts = Array(6).fill(0);
      const hints = Array(6).fill(0);
      for (const key in this.selected) {
          if (this.selected.hasOwnProperty(key)) {
            const parts = key.split('-');
            const val = this.selected[key];
            const i = Number(parts[1]) - 1;
            if (val === 1) {
                counts[i]++;
            }
            if (val === 2) {
                hints[i]++;
            }
          }
      }

      const result  = [];
      for (const i of [0, 1, 2]) {
          result.push(`${counts[i]}`);
      }
      for (const i of [3, 4, 5]) {
          const hint = hints[i] > 0 ? `+${hints[i]}` : '';
          result.push(`${counts[i]}${hint}`);
      }

      this.$emit('result', result);
  }

  public selectWord(word: string, n: number) {
      const mod = n < 4 ? 2 : 3;
      const val = this.selectedValue(word, n);
      this.selected[this.key(word, n)] = (val + 1) % mod;
      this.$emit('input', this.selected);
  }

  public getBoxColor(n: number) {
      return n === 5 ? '#1976D2' : (n === 6 ? '#512DA8' : '');
  }

  public selected: {[word: string]: number} = {};

  @Watch('value')
  public init() {
    this.selected = {};
    for (const word of this.words) {
        for (const n of Array(6).keys()) {
            const key = this.key(word, n + 1);
            const val = this.value && key in this.value ? this.value[key] : 0;
            Vue.set(this.selected, this.key(word, n + 1), val);
        }
    }
    this.emitResult();
  }

  public created() {
      this.init();
  }
}
